import { Button, withStyles } from '@material-ui/core';

// Red button for destructive order actions such as Cancel (change request of
// 06.10); Material-UI v4 buttons have no error colour of their own.
const DangerButton = withStyles((theme) => ({
  root: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
      '@media (hover: none)': {
        backgroundColor: theme.palette.error.main,
      },
    },
  },
}))(Button);

DangerButton.defaultProps = { variant: 'contained', disableElevation: true };

export default DangerButton;
